import type { DemoScript } from "../types";
import { WORKFLOW_SCRIPT_COPY } from "./workflow-script.copy";

export const buildWorkflowScript = (): DemoScript => [
  {
    id: "wf-intro",
    narrative: WORKFLOW_SCRIPT_COPY.wfIntro.narrative,
    durationMs: 3000,
  },
  {
    id: "wf-kanban",
    narrative: WORKFLOW_SCRIPT_COPY.wfKanban.narrative,
    zoomTargetId: "workflow-kanban",
    callout: {
      targetId: "workflow-kanban",
      text: WORKFLOW_SCRIPT_COPY.wfKanban.callout,
    },
    durationMs: 5200,
  },
  {
    id: "wf-overview",
    narrative: WORKFLOW_SCRIPT_COPY.wfOverview.narrative,
    durationMs: 2800,
  },
  {
    id: "wf-outro",
    narrative: WORKFLOW_SCRIPT_COPY.wfOutro.narrative,
    durationMs: 2800,
  },
];
